import type { RouteRecordRaw } from 'vue-router'
import ApaasRoutes from './Apaas'

export const routes = ([] as RouteRecordRaw[]).concat(ApaasRoutes)
